<template>
    <v-container class="fill-height">
        <v-layout text-center wrap>
            <v-flex mb-4>
                <div class="login-content">
                    <div v-html="loginContent" />
                </div>   

                <div class="content" :class="{'dynamic-host-mode': dynamicHostMode}">
                    <div class="title-container">
                        <h1 class="display-2 font-weight-bold mb-3">Login to TelsApp</h1>
                        <p class="subheading font-weight-regular">
                            Please visit the <a style="color:#c42111;" href="https://telsasoft.com" target="_blank">Telsasoft website</a>
                        </p>
                    </div>

                    <div style="margin: auto" class="login">
                        <v-combobox v-model="host" color="#c42111" label="Host" :items="hostList" prepend-icon="mdi-server" v-if="dynamicHostMode"></v-combobox>
                        <v-text-field autofocus v-model="username" color="#c42111" label="Username" prepend-icon="mdi-account"></v-text-field>
                        <v-text-field v-model="password" :type="'password'" color="#c42111" label="Password" prepend-icon="mdi-lock" @keyup.enter.native="login"></v-text-field>
                        <div class="login-button text-center">
                            <v-btn width="300" color="#c42111" @click="login">login</v-btn>
                        </div>
                        <span class="forgot-password-link" @click="forgotPasswordClick">Forgot your password?</span>
                    </div>

                    <v-btn class="authenticator-login-button" @click="startWebAuthnLogin([])" color="#2196F3" height="50" width="50">
                        <v-icon v-if="checkingForAuthenticator" large color="#FFFFFF">fas fa-spinner fa-spin</v-icon>
                        <v-icon v-else large color="#FFFFFF">mdi-fingerprint</v-icon>
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>


        <v-dialog v-model="showForgotPassword" max-width="80%" width="550px" persistent v-if="showForgotPassword">
            <forgot-password :existingUsername="username" @cancel="showForgotPassword = false"></forgot-password>
        </v-dialog>


    </v-container>
</template>

<script>
import Vue from 'vue';
import ForgotPassword from "@/components/ForgotPassword";
export default {
    name: 'Login',
    components: {
        ForgotPassword
    },
    data: () => ({
        username: '',
        password: '',
        host: '',
        hostList: [],
        dynamicHostMode: false,
        loginContent: '',
        showForgotPassword: false,
        webAuthnSignal: null,
        visibilityChangeProp: null,
        visibilityHiddenProp: null,
        checkingForAuthenticator: false
    }),

    computed: {
    },

    methods: {
        login: function() {
            let route = (TELSA.apiHost + "auth/login");
            TELSA.loading(true);
            let args = {username: this.username, 
                password: this.password, 
                telsaserver_host: this.host,
                login_secret: 'muT%t*jgeNmu&6v%'
            }
            return this.$http.post(route, {args: args}).then(response => {
                let applicationResources = response.body;
                TELSA.loading(false);
                document.removeEventListener(this.visibilityChangeProp, this.handleVisibilityChange); // We dont need this anymore

                // This triggers App.vue func to set the application resources
                this.$emit('applicationResources', applicationResources);

                // If dynamicHostMode then add this host to the list.
                if(this.dynamicHostMode) {
                    this.addHost();
                }

                this.navigateToStartPage(applicationResources);
            }, error => {
                TELSA.loading(false);
            });
        },

        addHost: function() {
            if(this.hostList.includes(this.host)) {
                this.hostList.splice(this.hostList.indexOf(this.host, 1));
            }
            this.hostList.unshift(this.host);
            localStorage.setItem('dynamicHostList', JSON.stringify(this.hostList));
        },

        getDynamicHostMode: function() {
            let route = (TELSA.apiHost + "auth/dynamichostmode");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                if(result == 'dynamic_host') {
                    this.dynamicHostMode = true;
                    let hostList = localStorage.getItem('dynamicHostList');
                    if(hostList) {
                        this.hostList = JSON.parse(hostList);
                    }
                    this.host = this.hostList[0];
                }
                else {
                    this.host = result;
                }
                TELSA.loading(false);
            }, error => {
                this.dynamicHostMode = false;
                TELSA.loading(false);
            });
        },

        getLoginPageContent: function() {
            let route = (TELSA.apiHost + "auth/loginpagecontent");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.loginContent = result;
                TELSA.loading(false);
            });
        },

        handleUpdatedCacheContent: function(event) {
            console.log('message found in login.vue', event);
            if(event.data.type == "CACHE_UPDATED" && event.data.payload.cacheName == "login-page-content") {
                caches.match(event.data.payload.updatedURL).then(resp => {
                    resp.text().then(updatedCachedContent => {
                        console.log(updatedCachedContent);
                        //updatedCachedContent = JSON.parse(updatedCachedContent);
                        //console.log(updatedCachedContent);
                        //updatedCachedContent = decodeURI(updatedCachedContent);
                        
                        updatedCachedContent = updatedCachedContent.replace(/['\\"]+/g, '"');
                        console.log(updatedCachedContent);

                        //updatedCachedContent = updatedCachedContent.substring(1, updatedCachedContent.length-1);
                        updatedCachedContent = updatedCachedContent.replace('"', '');
                        console.log(updatedCachedContent);
                        //updatedCachedContent = updatedCachedContent.slice(updatedCachedContent.lastIndexOf('"'), 1);
                        updatedCachedContent = updatedCachedContent.replace(/"([^"]*)$/, '$1');

                        console.log(updatedCachedContent);

                        this.loginContent = updatedCachedContent;
                    });
                });
            }
        },

        forgotPasswordClick: function() {
            this.showForgotPassword = true;
        },

        startWebAuthnLogin: function(allowCredentials) {
            if(!window.PublicKeyCredential) {
                console.log('WEB AUTHN DEVICE NOT SUPPORTED');
                return;
            }

            let route = (TELSA.apiHost + "auth/deviceauthenticatorlogin/4d3E7yS8drmj8RxSZtNaD3");
            this.checkingForAuthenticator = true;
            return this.$http.get(route).then(response => {
                let result = response.body;
                let publicKeyCredentialRequestOptions = result.authentication_options;
                let challenge_id = result.challenge_id;
                publicKeyCredentialRequestOptions.challenge = Uint8Array.from(publicKeyCredentialRequestOptions.challenge, c => c.charCodeAt(0)).buffer; // The challenege needs to be an ArrayBuffer
                publicKeyCredentialRequestOptions.allowCredentials = allowCredentials || [];
                this.webAuthnSignal = new AbortController();
                let credentialRequest = {publicKey: publicKeyCredentialRequestOptions, signal: this.webAuthnSignal.signal};

                navigator.credentials.get(credentialRequest).then(assertion => {
                    this.checkingForAuthenticator = false;
                    let assertionObj = {
                        authenticatorAttachment: assertion.authenticatorAttachment,
                        id: assertion.id,
                        rawId: btoa(String.fromCharCode(...new Uint8Array(assertion.rawId))),
                        response: {
                            authenticatorData: btoa(String.fromCharCode(...new Uint8Array(assertion.response.authenticatorData))),
                            clientDataJSON: btoa(String.fromCharCode(...new Uint8Array(assertion.response.clientDataJSON))),
                            signature: btoa(String.fromCharCode(...new Uint8Array(assertion.response.signature))),
                            userHandle: btoa(String.fromCharCode(...new Uint8Array(assertion.response.userHandle)))
                        },
                        type: assertion.type
                    };

                    TELSA.loading(true);
                    let postRoute = (TELSA.apiHost + "auth/deviceauthenticatorlogin");
                    return this.$http.post(postRoute, {args: {authenticator_login_secret: '4d3E7yS8drmj8RxSZtNaD3', assertionObj: assertionObj, challenge_id: challenge_id}}).then(loginResponse => {
                        TELSA.loading(false);
                        let applicationResources = loginResponse.body;
                        this.$emit('applicationResources', applicationResources);
                        this.navigateToStartPage(applicationResources);
                    });
                }).catch(error => {
                    this.checkingForAuthenticator = false;
                });
            });
        },

        navigateToStartPage: function(applicationResources) {
            console.log('applicationResources: ', applicationResources);
            // Navigate to start page
            if(applicationResources.batch_config.webapp_settings && applicationResources.batch_config.webapp_settings.preferences && applicationResources.batch_config.webapp_settings.preferences.startPage) {
                this.$router.push(applicationResources.batch_config.webapp_settings.preferences.startPage);
            }
            else {
                this.$router.push({ name: 'home' });
            }
        },

        checkForWebAuthnCredentials: function() {
            let logoutFlag = sessionStorage.getItem("logout");
            if(logoutFlag == 'manual') {
                // They just manually logged out and the app hasnt' refreshed yet. Don't start authenticator process but set flag to indicate that the refresh has occurred.
                sessionStorage.setItem("logout", 'autoreload');
                return;
            }
            else if(logoutFlag == 'autoreload') {
                // The had just manually logged out and the refresh has occured. Remove the logout flag so that next refresh it will do the authenticator process.
                sessionStorage.removeItem("logout");
                return;
            }

            let authenticator_credentials = localStorage.getItem('authenticator_credentials');
            if(authenticator_credentials && Array.isArray(JSON.parse(authenticator_credentials))) {
                authenticator_credentials = JSON.parse(authenticator_credentials);
                if(authenticator_credentials.length === 1) {
                    // There is just one so automatically initiate the webauthn login process IF the tab is focused.
                    let allowCredentials = authenticator_credentials.map(x => ({id: TELSA.hex2buf(x.authenticator_credential_id).buffer, transports: ["internal"], type: "public-key"}));
                    this.startWebAuthnLogin(allowCredentials);
                }
                else if(authenticator_credentials.length > 1) {
                    // Multiple account authenticators. It will ask the user which one after authentication ceremony.
                    this.startWebAuthnLogin([]);
                }
            }
        },

        handleVisibilityChange: function() {
            // Visibility of app has changed
            if (document[this.visibilityHiddenProp]) {
                // The app is hidden
                // abort the webauthn process
                if(this.webAuthnSignal) {
                    this.webAuthnSignal.abort('WebAuthn aborted: app visibility hidden');
                }
            } else {
                // The app is in view
            }
        },

        setupVisibilityChangeHandler: function() {
            if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
                this.visibilityHiddenProp = "hidden";
                this.visibilityChangeProp = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this.visibilityHiddenProp = "msHidden";
                this.visibilityChangeProp = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this.visibilityHiddenProp = "webkitHidden";
                this.visibilityChangeProp = "webkitvisibilitychange";
            }

            if(!this.visibilityHiddenProp) {
                console.log('Browser does not support Page Visibility API');
                return;
            }
            document.addEventListener(this.visibilityChangeProp, this.handleVisibilityChange, false);
        }
    },

    watch: {
    },

    created() {
        Vue.http.headers.common['X-Client-Version'] = this.$store.state.applicationVersion;

        // Setup handler for updating stale cached-content with latest content
        this.$workbox.addEventListener("message", this.handleUpdatedCacheContent);

        //this.getDynamicHostMode();
        this.getLoginPageContent();
    },

    mounted() {
        this.setupVisibilityChangeHandler();
        this.checkForWebAuthnCredentials();
    },

    destroyed() {

    }
};
</script>

<style scoped>

    .login {
        width: 490px;
        position: relative;
    }
    .login .login-button {
        margin-top: 1em;
    }
    
    .content {
        border: gray solid 1px;
        border-radius: 8px;
        background-color: #424242;
        width: fit-content;
        margin: 2em auto;
        padding: 2em;
        position: relative;
    }

    .login-content {
        text-align: -webkit-center;
        max-width: 90%;
        margin-left: 5%;
        max-height: calc(100vh - (0px + 560px));
        overflow-y: auto;
    }

    .login {
        text-align: center;
    }

    .login .forgot-password-link {
        color: #c42111;
        text-decoration: underline;
        cursor: pointer;
        position: relative;
        display: block;
        height: 0px;
        margin-top: 5px;
    }

    .authenticator-login-button {
        position: absolute;
        right: 1em;
        bottom: 1em;
    }

    @media (max-width: 600px) {
        .login {
            width: 100%;
        }

        .v-application .title-container .display-2.font-weight-bold.mb-3 {
            font-size: 24pt !important;
        }

        .content {
            width: 95%;
            height: 420px;
        }

        /* .login-content {  
            height: 60% !important;
            width: 60% !important;
        } */
    }
    
</style>


<style>



</style>
